import { type FC } from 'react';

import { Typography } from '@vakantiesnl/components/src/atoms/Typography';
import { useBreakpoints } from '@vakantiesnl/components/src/utils/useBreakpoints';
import { useMicroCopyContext } from '@vakantiesnl/services/src/context/microCopyContext';
import { usePriceToDecimalString } from '@vakantiesnl/services/src/hooks/utils/hook';
import { isNumber } from 'lodash';

import { useStyles } from './PriceTableRowItem.styles';

type Props = {
	title: string;
	/** When no priceTotal or it's 0 is added the item will be considered inclusive */
	priceTotal?: number;
	dataCy?: string;
};

export const PriceTableRowItem: FC<Props> = ({ priceTotal, title, dataCy }) => {
	const { isDesktop } = useBreakpoints();
	const microCopies = useMicroCopyContext();
	const { cx, classes } = useStyles();

	const price = usePriceToDecimalString(priceTotal || 0);
	return (
		<tr data-cy={dataCy ?? title}>
			<Typography variant={isDesktop ? 'bodyMd' : 'bodySm'} as="th">
				{title}
			</Typography>
			<Typography
				variant={isDesktop ? 'bodyMd' : 'bodySm'}
				as="td"
				className={cx({ [classes.positivePrice]: !priceTotal })}
			>
				{isNumber(priceTotal) ? price : microCopies['common.inclusive']}
			</Typography>
		</tr>
	);
};
